/**
 * TurnTo - Ratings and Reviews
 * Functions that support the TurnTo ratings and reviews
 * implementation. This is meant for small enhancements
 * that help bridge the gap between TurnTo capabilities
 * and UI/UX requirements.
 */

// Pixlee Type
declare const Pixlee: {
  init: (config: { apiKey: string }) => void;
  addCategoryWidget: (config: {
    containerId: string;
    accountId: string;
    widgetId: string;
    categoryName: string;
    skuId: string;
  }) => void;
  resizeWidget: () => void;
};

export const PixleeHook = {
  async mounted() {
    try {
      await this.loadPixlee();
      this.initPixlee();
    } catch (e) {
      console.error('Pixlee failed to load: ', e);
    }
  },
  loadPixlee() {
    return new Promise<void>((resolve, reject) => {
      const src = 'https://assets.pxlecdn.com/builds/20230830_173900_pixlee_widget_1_0_0.js';

      const scriptLoaded = Array.from(document.getElementsByTagName('script')).find(
        (script) => script.src === src
      );

      if (scriptLoaded) {
        return resolve();
      }

      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.onload = () => resolve();
      s.onerror = reject;
      s.src = src;
      document.body.appendChild(s);
    });
  },
  initPixlee() {
    const {
      dataset: { apiKey, accountId, categoryName, containerId, skuId, widgetId }
    } = this.el;

    Pixlee.init({ apiKey });
    Pixlee.addCategoryWidget({
      containerId,
      accountId,
      widgetId,
      categoryName,
      skuId
    });
    Pixlee.resizeWidget();
  }
};
